// setItem,
import { getItem, removeItem } from "@/utils/storage"; // getItem和setItem是封装的操作localStorage的方法
export const TOKEN = "VEA-TOKEN";
const SIGNSTATE = "SERVICE-DOCHECKIN";
const SIGNSOCKET = "SERVICE-SOCKET";

export default {
  namespaced: true,
  state: {
    crmdialid: "",
    // 是否签入-0 签出 - 签入
    docheckin: 0,
    // 是否已经拨号，然后处于通话中
    calling: false,
    // 拨号中不算，是否处在通话中
    onalinePhone: false,
    socketInstance: getItem(SIGNSTATE) || null,
    soundOffText: "静音",
    // 拨号时后端需要的字段 id, phoneNo
    whPhoneData: {},
  },
  mutations: {
    setCrmdialid(state, data) {
      state.crmdialid = data;
    },
    setSignState(state, data) {
      state.docheckin = data;
      // 保存到localStorage
      // console.log("state.docheckin", state.docheckin);
      // setItem(SIGNSTATE, state.docheckin)
    },
    setCalling(state, data) {
      state.calling = data;
    },
    setOnalinePhone(state, data) {
      state.onalinePhone = data;
    },
    setSundOffText(state, data) {
      state.soundOffText = data;
    },
    setWhPhoneData(state, data) {
      state.whPhoneData = data;
    },
    clearToken(state) {
      state.docheckin = 0;
      removeItem(SIGNSTATE);
    },
    setSocketInstance(state, data) {
      state.socketInstance = data;
    },
    clearSocketInstance() {
      removeItem(SIGNSOCKET);
    },
  },
  actions: {
    clearSocket({ commit }) {
      // 清除token
      commit("clearToken");
      // 清除用户信息
      commit("account/clearUserinfo", "", { root: true });
      // 清除标签栏
      commit("tags/CLEAR_ALL_TAGS", "", { root: true });
      // 清空menus
      commit("menu/SET_MENUS", [], { root: true });
    },
  },
};
